import * as _ from 'underscore';

import * as Config from '../config';
import * as appTheme from '../../../../_common/platform/ts/appTheme';
import { init as widgetTheme } from '../../../../pdc-platform/src/ts/themes/widgetTheme';
import { validators } from '../../../../_common/platform/ts/validators';

import NumberField from '../../../../_common/platform/ts/NumberField';
import BooleanField from '../../../../_common/platform/ts/BooleanField';
import StringField from '../../../../_common/platform/ts/StringField';
import { TitlePositionSelect } from '../../../../_common/platform/tsx/TitlePositionSelect';

const _init = [];

export function init(glob) {
    if (_.indexOf(_init, glob) !== -1) {
        return;
    }

    widgetTheme(glob);

    appTheme.registerSections([
        {
            id: Config.themeId,
            name: Config.name,
            parent: 'widget',

            themeType: Config.name,
            visibility: ['application', 'workspace', Config.moduleName]
        }
    ]);

    appTheme.registerVars([
        {
            id: Config.themeFields.autoApplyMode,
            param: new BooleanField(glob, 'Auto Apply Mode', [], false),
            section: Config.themeId
        },
        {
            id: Config.themeFields.titlePosition,
            param: new TitlePositionSelect(glob),
            section: Config.themeId
        },
        {
            id: Config.themeFields.titleWidth,
            param: new NumberField(
                glob,
                'Width of Field Label',
                [validators.number.not_negative, validators.number.integer],
                null,
                {
                    allowNull: true
                }
            ),
            section: Config.themeId
        },
        {
            id: Config.themeFields.verticalSpacing,
            param: new NumberField(
                glob,
                'Vertical Space Between Fields',
                [validators.number.not_negative, validators.number.integer],
                null,
                {
                    allowNull: true
                }
            ),
            section: Config.themeId
        },
        {
            id: Config.themeFields.applyButtonTitle,
            param: new StringField(glob, 'Apply Button Title', [validators.string.length(0, 40)], null, {
                allowNull: true,
                placeholder: 'Apply'
            }),
            section: Config.themeId
        },
        {
            id: Config.themeFields.hideCancelButton,
            param: new BooleanField(glob, 'Hide Cancel Button', [], false),
            section: Config.themeId
        },
        {
            id: Config.themeFields.hideApplyButton,
            param: new BooleanField(glob, 'Hide Apply Button', [], false),
            section: Config.themeId
        }
    ]);

    _init.push(glob);
}
